function normalizeExposure(value) {
  if (typeof value === 'boolean') return value;
  if (value === 'true' || value === '1') return true;
  if (value === 'false' || value === '0') return false;
  return undefined;
}

function readInsightsExposureSignal() {
  if (typeof window === 'undefined') return undefined;
  return normalizeExposure(window.narcityInsights && window.narcityInsights.exposure);
}

function resolveConfiguredInsights(config, context) {
  if (typeof config === 'function') {
    try {
      return config(context || {}) || {};
    } catch (_) {
      return {};
    }
  }
  return config && typeof config === 'object' ? config : {};
}

function readInsightsExposureContext(config, context) {
  const configured = resolveConfiguredInsights(config, context);
  if (typeof window === 'undefined') {
    const exposure = normalizeExposure(configured.exposure);
    const campaignId = typeof configured.exposureCampaignId === 'string'
      ? configured.exposureCampaignId
      : (typeof configured.campaignId === 'string' ? configured.campaignId : '');
    return {
      exposure,
      exposureEligible: configured.eligible === true
        || configured.exposureEligible === true
        || Boolean(campaignId)
        || typeof exposure === 'boolean',
      exposureCampaignId: campaignId
    };
  }

  const source = {
    ...(window.narcityInsights || {}),
    ...configured
  };
  const exposure = normalizeExposure(source.exposure);
  const campaignId = typeof source.exposureCampaignId === 'string'
    ? source.exposureCampaignId
    : (typeof source.campaignId === 'string' ? source.campaignId : '');
  const eligible = source.eligible === true
    || source.exposureEligible === true
    || Boolean(campaignId)
    || typeof exposure === 'boolean';

  return {
    exposure,
    exposureEligible: eligible,
    exposureCampaignId: campaignId
  };
}

module.exports = {
  readInsightsExposureSignal,
  readInsightsExposureContext
};
